import { Field } from 'formik'
import React from 'react'
import InputContainer from '../InputContainer'
import InputLabel from '../InputLabel'

function TextInput({ field, ...rest }) {


    return (
        <InputContainer>
            <InputLabel text={field.prompt} htmlfor={field.name}/>
            <Field id={field.name} name={field.name} className=" p-3 border border-gray-500" />
        </InputContainer>
    )
}

export default TextInput